export default __webpack_public_path__ + "static/media/Connecticut1Open.b02c58e3.jpg";